exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3lAPGofcToBUzZDsmp_fP3{width:30px;height:28px}html[dir=ltr] ._3lAPGofcToBUzZDsmp_fP3{margin-left:20px}html[dir=rtl] ._3lAPGofcToBUzZDsmp_fP3{margin-right:20px}._3jhhOtq1MlhFEXg3iqtxDc{display:table-row}._1Z-lQSCUBuJ4-UwqsBd0mI{display:table-cell}html[dir] ._1Z-lQSCUBuJ4-UwqsBd0mI{padding-bottom:4px}", ""]);
// Exports
exports.locals = {
	"numInput": "_3lAPGofcToBUzZDsmp_fP3",
	"insertTableDialogRow": "_3jhhOtq1MlhFEXg3iqtxDc",
	"insertTableDialogCell": "_1Z-lQSCUBuJ4-UwqsBd0mI"
};